import { createTheme } from '@mui/material';
import { overrideTheme } from '@aspendental/themes';

import { TAGBrand } from '@/types';
import { resolveBrandThemeConfig } from '@/utils';

const themeCache = new Map<TAGBrand, ReturnType<typeof createTheme>>();

/**
 * Gets a theme object for a specific brand
 */
export const getBrandTheme = (brand: TAGBrand) => {
	if (!themeCache.has(brand)) {
		const brandTheme = resolveBrandThemeConfig(brand);
		const theme = createTheme(
			overrideTheme(brandTheme, {
				brand: brand,
			})
		);
		themeCache.set(brand, theme);
	}

	return themeCache.get(brand);
};

/**
 * Gets a specific color value from a brand's theme
 * @param brand The brand to get the color from
 * @param path Path to the color value (e.g., 'palette.accent1.main')
 */
export const getBrandThemeColor = (brand: TAGBrand, path: string) => {
	const theme = getBrandTheme(brand);

	if (!theme) return null;
	// Navigate through the path to get the specific value
	return path
		.split('.')
		.reduce(
			(obj: Record<string, unknown>, key: string) => obj?.[key] as Record<string, unknown>,
			theme as unknown as Record<string, unknown>
		);
};
